import { ViewportProvider } from './hooks/useIsMobile';
import { QueryClient, QueryClientProvider } from 'react-query';
import { lazy } from 'react';
import { AppType } from './models/AppType';
import { getAppType } from './utils/getAppType';

const FormApp = lazy(() => import('./FormApp'));
const DataRequestApp = lazy(() => import('./DataRequestApp'));

const appType = getAppType();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

const Content = () => {
  if (appType === AppType.DATA_REQUEST) {
    return <DataRequestApp />;
  }

  return <FormApp />;
};

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ViewportProvider>
        <Content />
      </ViewportProvider>
    </QueryClientProvider>
  );
}

export default App;
